import { render } from "./AppZKDB.vue?vue&type=template&id=0a0a2246"
import script from "./AppZKDB.vue?vue&type=script&lang=js"
export * from "./AppZKDB.vue?vue&type=script&lang=js"

import "./AppZKDB.vue?vue&type=style&index=0&id=0a0a2246&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__